import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './ProductPage.scss';
import Breadcrumb from '../../components/common/Breadcrumb';

// public/images/ 폴더 내 실제 파일명과 매칭
const productImages = {
  eva: '/images/tape8.png',
  pe: '/images/tape9.png',
};

const Foam = () => {
  const { subcategory } = useParams();
  const navigate = useNavigate();

  const products = {
    eva: {
      title: 'EVA폼 테이프',
      eng: 'EVA Foam Tape',
      desc: '충격 흡수와 방진, 틈새 메움 용도에 적합하며 자동차, 가전, 건축 분야에서 폭넓게 사용되는 EVA 폼 테이프입니다.',

      summary: {
        productName: 'EVA폼 테이프',
        usage: 'DIY / 자동차 / 가전 / 건축',
        size: '500*20 / (25*20)',
      },

      strengths: [
        '충격 흡수 및 진동 완화에 우수',
        '울퉁불퉁한 면에도 밀착되는 틈새 메움 기능',
        '방진, 방음 효과 뛰어남',
        '곡면, 라운드형 제품에도 시공 용이',
        '다양한 두께 선택 가능',
        '가벼운 소재 부착에 최적화',
        '시공 편리하고 가성비 우수',
      ],

      cautions: ['고온에서 접착력이 떨어짐', '무거운 금속 부착에는 부적합'],

      tableHeaders: ['모델명', '기재', '점착제', '두께(mm)', '색상', '점착력(gf/in)', '내열성'],

      tableRows: [['EVA (1T)', 'EVA폼', '솔벤트(아크릴)', '1', '불투명', '2,300', '-']],
    },
    pe: {
      title: 'PE폼 테이프',
      eng: 'PE Foam Tape',
      desc: '완충, 방진, 생활 고정용으로 폭넓게 활용되는 범용 PE 폼 양면테이프입니다.',

      summary: {
        productName: 'PE 폼 테이프',
        usage: '벽면 걸이 / 가전 내부 완충재 / 몰딩 등',
        size: '1000*10 / 1000*15 / 1000*20 외',
      },

      strengths: [
        '가벼운 무게와 우수한 탄성',
        '곡면, 불규칙 표면에도 밀착 우수',
        '완충, 진동 흡수 성능 뛰어남',
        '습기, 수분에 강한 내수성',
        '다양한 두께 선택 가능',
        '생활, 사무, 가전, 인테리어 등 범용 활용성',
        '가성비 뛰어난 폼 테이프 솔루션',
      ],

      cautions: ['고중량, 고하중에는 부적합'],

      tableHeaders: ['모델명', '기재', '점착제', '두께(mm)', '색상', '점착력(gf/in)', '내열성'],

      tableRows: [['PE폼 (적)', 'PE폼', '솔벤트(아크릴)', '1', '적색, 검정색', '2,300', '-']],
    },
  };

  const currentKey = subcategory || 'eva';
  const current = products[currentKey] || products['eva'];

  return (
    <div className="sub-page product-page">
      <section className="sub-visual product">
        <div className="container">
          <span className="sub-title">PRODUCT</span>
          <h1>제품소개</h1>
          <p>완충과 고정 성능이 극대화된 고성능 폼 솔루션입니다.</p>
        </div>
      </section>

      <Breadcrumb />

      <nav className="category-nav">
        <div className="container">
          <div className="nav-inner">
            <button onClick={() => navigate('/products/double-sided/whaja')}>양면 테이프</button>
            <button onClick={() => navigate('/products/industrial/masking')}>산업용 테이프</button>
            <button className="active" onClick={() => navigate('/products/foam/eva')}>
              폼 테이프
            </button>
          </div>
        </div>
      </nav>

      <div className="container content-wrap">
        <nav className="product-tabs">
          {Object.keys(products).map((key) => (
            <button
              key={key}
              className={currentKey === key ? 'active' : ''}
              onClick={() => navigate(`/products/foam/${key}`)}
            >
              {products[key].title}
            </button>
          ))}
        </nav>

        <div className="product-detail-view">
          <div className="detail-main">
            {/* 좌측 이미지 영역 */}
            <div className="img-area">
              <div className="img-box">
                <img src={productImages[currentKey]} alt={current.title} />
              </div>
            </div>

            {/* 우측 정보 영역 (DoubleSided와 동일한 info-area-redesign 구조) */}
            <div className="info-area info-area-redesign">
              <div className="product-head">
                <span className="eng-title">{current.eng}</span>
                <h2>{current.title}</h2>
                <p className="main-desc">{current.desc}</p>
              </div>

              <div className="spec-table-container">
                <table className="spec-table">
                  <tbody>
                    <tr>
                      <th>품명</th>
                      <td>
                        <strong>{current.summary.productName}</strong>
                      </td>
                    </tr>
                    <tr>
                      <th>사용처</th>
                      <td>{current.summary.usage}</td>
                    </tr>
                    <tr>
                      <th>특장점</th>
                      <td>
                        <ul className="spec-list strengths">
                          {current.strengths.map((s, idx) => (
                            <li key={idx}>{s}</li>
                          ))}
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <th>규격</th>
                      <td>{current.summary.size}</td>
                    </tr>
                    <tr>
                      <th>주의사항</th>
                      <td>
                        <ul className="spec-list cautions">
                          {current.cautions.map((c, idx) => (
                            <li key={idx}>{c}</li>
                          ))}
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* 하단 상세 데이터 */}
          <div className="data-table-wrap full-width">
            <div className="table-title">상세 규격 데이터 (Technical Specification)</div>
            <div className="table-scroll">
              <table className="product-data-table">
                <thead>
                  <tr>
                    {current.tableHeaders.map((head, idx) => (
                      <th key={idx}>{head}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {current.tableRows.map((row, rowIdx) => (
                    <tr key={rowIdx}>
                      {row.map((cell, cellIdx) => (
                        <td key={cellIdx}>{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Foam;
